<template lang="pug">
  .view-control-reports-detailed-lesson
    statistic(:url="statisticUrl")
</template>

<script>
export default {
  name: 'view-control-reports-detailed-test',

  computed: {
    statisticUrl() {
      return this.$route.params.userId
        ? `/statistics/tests-progress/${this.$route.params.testId}/users/${this.$route.params.userId}`
        : `/statistics/tests-progress/${this.$route.params.testId}`;
    },
  },
};
</script>
